/**
 * Promo Feature Banner Block
 *
 * @class rlPromoFeaturedBanner
 * @memberOf jQuery.fn
 */

(function($) {
    $.fn.rlPromoFeatureBanner = function () {
        //////
        //FBB Promotion Block Specific Functions
        //////

        var getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }
            return false;
        };

        function promoImg(target, remove, add, hidden) {
            target.removeClass(remove).addClass(add).attr('aria-hidden', hidden);
        }

        function getCookie(name) {
            let cookie = {};
            document.cookie.split(';').forEach(function (el) {
                let [k, v] = el.split('=');
                cookie[k.trim()] = v;
            })
            return cookie[name];
        }

        //Get Campaign Code URL parameter
        let CampaignCode = getUrlParameter('CampaignCode'),
            codeParameterText = 'CampaignCode';
        if (CampaignCode == false) {
            CampaignCode = getUrlParameter('utm_campaign');
            codeParameterText = 'utm_campaign';
        }

        // Cookie
        const CampaignCodeCookie = "CampaignCode",
              CampaignCodeURLCookie = 'CampaignURL';
              GetCampaignCodeCookie = getCookie(CampaignCodeCookie),
              GetCampaignCodeURLCookie = getCookie(CampaignCodeURLCookie);

        let URLCurrent = document.URL,
            URLCookieIndex = URLCurrent.indexOf("?"),
            URLCookie = URLCurrent.substring(0, URLCookieIndex),
            ApiAddress = '/api/GetPromotionItemForCampaign/?CampaignCode=' + CampaignCode;

        if (CampaignCode === false) {
            ApiAddress = '/api/GetPromotionItemForCampaign/?CampaignCode=' + GetCampaignCodeCookie;
        }

        ///
        /// Set Cookie
        ///
        $(window).on('OneTrustGroupsUpdated', function () {
            // if consent has been given
            if (typeof OnetrustActiveGroups !== undefined && OnetrustActiveGroups.split(',').indexOf('C0001') !== -1) {
                if (CampaignCode != false) {
                    document.cookie = CampaignCodeCookie + '=' + CampaignCode + '; path=/';
                    document.cookie = CampaignCodeURLCookie + "=" + URLCookie + '; path=/';
                }
            }
        });

        if (CampaignCode != false || GetCampaignCodeCookie && GetCampaignCodeURLCookie === URLCurrent) {
            $.getJSON(ApiAddress, function (data) {

                ///
                /// API data retrieval
                ///

                //campaign strings
                const campFlashAlt = JSON.stringify(data['CampaignFlashAltText']).slice(1, -1),
                    campTermsTitle = JSON.stringify(data['TermsTitle']).slice(1, -1);

                let campTermsUrl = JSON.stringify(data['TermsUrl']);
                if (campTermsUrl != 'null') { campTermsUrl = campTermsUrl.slice(1, -1) }

                //date - today
                let today = new Date();
                todaysMonth = today.getMonth() + 1,
                    todaysDay = today.getDate();

                if (todaysMonth.toString().length == 1) {
                    todaysMonth = '0' + todaysMonth;
                }
                if (todaysDay.toString().length == 1) {
                    todaysDay = '0' + todaysDay;
                }

                const todaysDate = today.getFullYear() + '-' + todaysMonth + '-' + todaysDay;
                const openDate = (today.getFullYear() + 10 ) + '-' + todaysMonth + '-' + todaysDay;

                //date - start
                let campStart = JSON.stringify(data['PromoStart']).slice(1, -1),
                    campStartIndex = campStart.indexOf('T'),
                    campStartCleaned = campStart.slice(0, campStartIndex);

                //date - end
                let campEnd = JSON.stringify(data['PromoExpire']),
                    campEndIndex = 0,
                    campEndCleaned = 0;

                if (campEnd != "null") {
                    campEnd = campEnd.slice(1, -1);
                    campEndIndex = campEnd.indexOf('T'),
                    campEndCleaned = campEnd.slice(0, campEndIndex);
                }
                else {
                    campEndCleaned = openDate;
                }


                //is countdown active
                const LocalDate = JSJoda.LocalDate;
                function getNumberOfDays(start, end) {
                    const start_date = new LocalDate.parse(start);
                    const end_date = new LocalDate.parse(end);
                    return JSJoda.ChronoUnit.DAYS.between(start_date, end_date);
                }
                const daysLeftOnCountdown = getNumberOfDays(todaysDate, campEndCleaned) + 1;


                //date - countdown
                const campCountdownRange = JSON.stringify(data['CountdownRange']),
                    campCountdownText = JSON.stringify(data['CountdownText']).slice(1, -1);

                let campDetailsBannerTerms = JSON.stringify(data['DetailsBannerTerms']),
                    campDetailsBannerTermsBelow = JSON.stringify(data['DetailsBannerTermsBelow']);

                if (campDetailsBannerTerms != "null") {
                    campDetailsBannerTerms = campDetailsBannerTerms.slice(1, -1);
                }

                if (campDetailsBannerTermsBelow != "null") {
                    campDetailsBannerTermsBelow = campDetailsBannerTermsBelow.slice(1, -1);
                }

                let campCountdownDay = 'days',
                    campAdverb = ' in ',
                    daysLeftText = 0;

                if (daysLeftOnCountdown == 1 || daysLeftOnCountdown == 2) {
                    daysLeftText = '';
                    campAdverb = ' ';
                }
                else {
                    daysLeftText = daysLeftOnCountdown;
                }
                if (daysLeftOnCountdown == 1) {
                    campCountdownDay = 'today';
                }
                else if (daysLeftOnCountdown == 2) {
                    campCountdownDay = 'tomorrow';
                }

                //image fields
                let campFlashUrl = JSON.stringify(data['CampaignFlash']),
                    campDetailsImgMobile = JSON.stringify(data['DetailsImgMobile']),
                    campDetailsImgDesktop = JSON.stringify(data['DetailsImgDesktop']);

                //slice image urls if not null
                if (campFlashUrl != 'null') { campFlashUrl = campFlashUrl.slice(1, -1) }
                if (campDetailsImgMobile != 'null') { campDetailsImgMobile = campDetailsImgMobile.slice(1, -1) }
                if (campDetailsImgDesktop != 'null') { campDetailsImgDesktop = campDetailsImgDesktop.slice(1, -1) }

                ///check if one campDetailsImg needs to replace the other
                if (campDetailsImgMobile == 'null' && campDetailsImgDesktop.length > 0) {
                    campDetailsImgMobile = campDetailsImgDesktop;
                }
                if (campDetailsImgDesktop == 'null' && campDetailsImgMobile.length > 0) {
                    campDetailsImgDesktop = campDetailsImgMobile;
                }

                ///
                /// Build API data html
                ///

                const promoFlash = '.promoflash',
                    promoDetails = '.promodetails',
                    promoCountdownFormattedText = campCountdownText + campAdverb + daysLeftText + ' ' + campCountdownDay + '!';

                //build campaign image
                $(promoFlash).attr('data-campaign', CampaignCode);
                if (campFlashUrl != 'null') {
                    $('<div class="campaign hide" aria-hidden="true"><img alt="' + campFlashAlt + '" src="' + campFlashUrl + '"/></div>').appendTo(promoFlash);
                }
                if (campCountdownRange != 'null' && campCountdownText != '' && daysLeftOnCountdown > 0 && daysLeftOnCountdown <= campCountdownRange && campDetailsImgMobile == 'null' && campDetailsImgDesktop == 'null') {
                    $('<p class="countdown">' + promoCountdownFormattedText + '</p>').appendTo('.promoflash .campaign');
                }
                if (campTermsTitle != '\"\"' && campTermsUrl != '\"\"' && campTermsUrl != 'null' && campDetailsImgMobile == 'null' && campDetailsImgDesktop == 'null') {
                    $('<span class="link"><a title="' + campTermsTitle + '" href="' + campTermsUrl + '"><span>' + campTermsTitle + '</span></a></span>').appendTo('.promoflash .campaign');
                }


                //build campaign promo details banner
                $(promoDetails).attr('data-campaign', CampaignCode);
                if (campDetailsImgMobile != 'null') {
                    $('<img class="campaign mobile" alt="' + campFlashAlt + '" src="' + campDetailsImgMobile + '"/>').appendTo('.promodetails .image');
                }
                if (campDetailsImgDesktop != 'null') {
                    $('<img class="campaign desktop" alt="' + campFlashAlt + '" src="' + campDetailsImgDesktop + '"/>').appendTo('.promodetails .image');
                }
                if (campDetailsImgMobile != 'null' && campDetailsImgDesktop != 'null') {

                    $('<p class="campaign"></p>').appendTo('.promodetails .terms .wrap');

                    const campText = '.promodetails .terms p.campaign';

                    if (campCountdownRange != 'null' && campCountdownText != '' && daysLeftOnCountdown > 0 && daysLeftOnCountdown <= campCountdownRange) {
                        $('<span class="countdown">' + promoCountdownFormattedText + '</span>').appendTo(campText);
                    }

                    if (campDetailsBannerTerms != 'null') {
                        $('<div class="tiny before">' + campDetailsBannerTerms + '</div>').appendTo(campText);
                    }

                    if (campTermsTitle != '\"\"' && campTermsUrl != '\"\"' && campTermsUrl != 'null') {
                        $('<div class="tclink"><a title="' + campTermsTitle + '" href="' + campTermsUrl + '">' + campTermsTitle + '</a></div>').appendTo(campText);
                    }

                    if (campDetailsBannerTermsBelow != 'null') {
                        $('<div class="tiny after">' + campDetailsBannerTermsBelow + '</div>').appendTo(campText);
                    }

                }

                //is promo date active
                if (promoActiveDateCheck(campStartCleaned, campEndCleaned, todaysDate)) {
                    $(promoFlash).attr('data-datesactive', 'true');
                    $(promoDetails).attr('data-datesactive', 'true');
                }
                else {
                    $(promoFlash).attr('data-datesactive', 'false');
                    $(promoDetails).attr('data-datesactive', 'false');
                }

                //////////////////////
                /// date functions ///
                //////////////////////

                function promoActiveDateCheck(start, end, today) {

                    var fDate, lDate, cDate;
                    fDate = Date.parse(start);
                    lDate = Date.parse(end);
                    cDate = Date.parse(today);

                    if (isNaN(parseInt(fDate)) && cDate <= lDate || isNaN(parseInt(lDate)) && cDate >= fDate) {
                        return true;
                    }
                    else if (isNaN(parseInt(fDate)) && isNaN(parseInt(lDate))) {
                        return true;
                    }
                    else if ((cDate <= lDate && cDate >= fDate)) {
                        return true;
                    }
                    else {
                        return false;
                    }

                }
            }).fail(function (status) {
                $('.promoflash, .promodetails').each(function () {
                    $(this).attr('data-campaign', 'error');
                });
            });

            ///
            /// Set DOM Element State(s)
            /// listen to API changes made to the data attributes
            var promoEl = document.querySelector('.promoflash');
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === "attributes") {

                        //Flash image
                        $('.promoflash').each(function () {

                            const promoDefault = $(this).find('.default'),
                                promoCampaign = $(this).find('.campaign'),
                                dataCampaign = $(this).attr('data-campaign'),
                                dataDatesActive = $(this).attr('data-datesactive'),
                                dataDisableCampaign = $(this).attr('data-disable');

                            //set campaign flash image & terms
                            if (dataCampaign !== '' && dataDatesActive === 'true' && dataDisableCampaign !== 'True') {
                                promoImg(promoDefault, 'show', 'hide', 'true');
                                promoImg(promoCampaign, 'hide', 'show', 'false');

                                ///set parameters on the cta buttons (for transactional journey reasons)
                                const buttonContainer = $(this).parents('.featurebanner-container').find('.featurebanner-content'),
                                    primaryButton = buttonContainer.find('.cta-first'),
                                    primaryHref = primaryButton.attr('href'),
                                    secondaryButton = buttonContainer.find('.cta-second'),
                                    secondaryHref = secondaryButton.attr('href'),
                                    thirdButton = buttonContainer.find('.cta-third'),
                                    thirdHref = thirdButton.attr('href'),
                                    ctaQueryString = '?' + codeParameterText + '=' + CampaignCode;

                                if (primaryButton.length > 0 && primaryHref.indexOf(ctaQueryString) === -1) {
                                    SetParametersOnCTA(primaryButton, primaryHref);
                                }
                                if (secondaryButton.length > 0 && secondaryHref.indexOf(ctaQueryString) === -1) {
                                    SetParametersOnCTA(secondaryButton, secondaryHref);
                                }
                                if (thirdButton.length > 0 && thirdHref.indexOf(ctaQueryString) === -1) {
                                    SetParametersOnCTA(thirdButton, thirdHref);
                                }
                                function SetParametersOnCTA($button, $Href) {
                                    if ($Href.includes('#')) {
                                        let hashIndex = $Href.indexOf('#'),
                                            linkString = $Href.substring(0, hashIndex),
                                            hashString = $Href.substring(hashIndex);

                                        $button.attr('href', linkString + ctaQueryString + hashString).addClass('externalbutton');
                                    }
                                    else {
                                        $button.attr('href', $Href + ctaQueryString);
                                    }
                                }

                            }

                            //set default flash image & terms
                            else {
                                promoImg(promoDefault, 'hide', 'show', 'false');
                                promoImg(promoCampaign, 'show', 'hide', 'true');
                            }

                        });

                        //Details banner
                        $('.promodetails').each(function () {

                            const detailsImageDefault = $(this).find('.image .default'),
                                detailsImageCampaign = $(this).find('.image .campaign'),
                                detailsTextDefault = $(this).find('.terms .default'),
                                detailsTextCampaign = $(this).find('.terms .campaign'),

                                dataCampaign = $(this).attr('data-campaign'),
                                dataDatesActive = $(this).attr('data-datesactive'),
                                dataDisableCampaign = $(this).attr('data-disable');


                            //set campaign flash image & terms
                            if (dataCampaign !== '' && dataDatesActive === 'true' && dataDisableCampaign !== 'True') {
                                promoImg(detailsImageDefault, 'show', 'hide', 'true');
                                promoImg(detailsImageCampaign, 'hide', 'show', 'false');
                                promoImg(detailsTextDefault, 'show', 'hide', 'true');
                                promoImg(detailsTextCampaign, 'hide', 'show', 'false');
                            }

                            //set default flash image & terms
                            else {
                                promoImg(detailsImageDefault, 'hide', 'show', 'false');
                                promoImg(detailsImageCampaign, 'show', 'hide', 'true');
                                promoImg(detailsTextDefault, 'hide', 'show', 'false');
                                promoImg(detailsTextCampaign, 'show', 'hide', 'true');
                            }

                            //expired, non-existant or disabled campaign settings?
                            if ($(this).data('campaign') === 'error' || dataDatesActive === 'false' || dataDisableCampaign === 'True') {
                                if ($(this).find('.image .default').length === 0) {
                                    $(this).removeClass('show').addClass('hide');
                                }
                                else {
                                    $(this).removeClass('hide').addClass('show');
                                }
                            }

                            //Does details banner container need to show itself on campaign settings?
                            else if ($(this).find('.image .campaign').length > 0) {
                                if (dataDatesActive === 'false') {
                                    $(this).removeClass('show').addClass('hide');
                                }
                                else {
                                    $(this).removeClass('hide').addClass('show');
                                }
                            }
                            else {
                                $(this).removeClass('show').addClass('hide');
                            }

                        });
                    }
                });
            });


            observer.observe(promoEl, {
                attributes: true
            });
        }

        else {

            //Default flash image states
            $('.promoflash').each(function () {
                promoImg($(this).find('.default'), 'hide', 'show', 'false');
            });

            //Default details banner states
            $('.promodetails').each(function () {
                promoImg($(this).find('.image .default'), 'hide', 'show', 'false');
                promoImg($(this).find('.terms .default'), 'hide', 'show', 'false');

                //Does details banner container need to show itself on default settings?
                if ($(this).find('.image .default').length > 0) {
                    $(this).removeClass('hide').addClass('show');
                }
                else {
                    $(this).removeClass('show').addClass('hide');
                }
            });
        }

        //match height of columns on full-width-image layout.
        $('.featurebannerpromotionblock .image-full-width .promoflash, .featurebannerpromotionblock .image-full-width .featurebanner-content').matchHeight();

    };
}(jQuery));